<template>
  <div v-if="pictures.length > 0">
    <flickity ref="flickity" :options='flickityOptions'>
      <div
        class="carousel-cell"
        v-for="picture in pictures"
        :key="pictures.indexOf(picture)">

        <v-layout :class="layoutDirection">
          <v-layout column>
            <div class="image-meals">
              <img
                :data-flickity-lazyload="picture.withdrawal"
                alt="Imagem da retirada"
                @click="openImageDialog(picture.withdrawal)">
            </div>
          </v-layout>

          <v-layout column :class="imageAlign">
            <div class="image-meals">
              <div :class=" { placeholder: shouldShowPlaceholder(picture.devolution) }">
                <img
                  :data-flickity-lazyload="pictureToShow(picture.devolution)"
                  alt="Imagem da devolução"
                  @click="openImageDialog(picture.devolution)">
              </div>
            </div>
          </v-layout>
        </v-layout>
      </div>
    </flickity>

    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-actions class="py-0">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            icon
            flat
            @click="closeDialog"
          >
            X
          </v-btn>
        </v-card-actions>

        <v-card-text class="pt-0">
          <div class="image-meals">
            <img :src="imageSelected">
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  <v-layout v-else align-center justify-center row>
    Não há registros para esta refeição.
  </v-layout>
</template>

<script>
import Flickity from 'vue-flickity'
/**
 * @group Meal Control
 * Implementa o componente externo [vue-flickity](https://flickity.metafizzy.co/)
 * que possibilita a vizualização de multiplas bandejas pelo usuário.
 */
export default {
  name: 'TraysFlickity',

  components: {
    Flickity
  },

  props: {
    // Imagens que serão exibidas no flickity
    pictures: {
      type: Array,
      // []
      default () { return [] }
    },
    // Direção em que será feita a exibição
    layoutDirection: {
      // 'column'/'row'
      type: String,
      default: 'row'
    },
    // Alinhamento interno entre as imagens, sendo posto sobre a segunda imagem
    imageAlign: {
      type: Array,
      // []
      default () { return [] }
    }
  },

  data: () => ({
    dialog: false,
    imageSelected: ''
  }),

  computed: {
    flickityOptions () {
      return {
        prevNextButtons: (this.pictures || []).length > 1,
        pageDots: false,
        wrapAround: false,
        lazyLoad: true
      }
    }
  },

  updated () {
    if (this.$refs.flickity) {
      this.$refs.flickity.rerender()
    }
  },

  methods: {
    // @vuese
    // Fecha dialog de imagens
    closeDialog () {
      this.dialog = false
    },
    /** @vuese
     * Valida a abertura da dialog se possuir uma imagem
     * @arg Passa a url da imagem
     */
    openImageDialog (image) {
      if (image) {
        this.imageSelected = image
        this.dialog = !this.dialog
      }
    },
    /** @vuese
     * Trata a exibição da imagem
     * @arg Passa a url da imagem
     */
    pictureToShow (picture) {
      return picture || require('@/assets/images/placeholders/dishes_placeholder.svg')
    },
    // @vuese
    // Trata a exibição da classe css interna *placeholder*
    // @arg Passa a url da imagem
    shouldShowPlaceholder (picture) {
      return !picture
    }
  }
}
</script>

<style lang="stylus" scoped>
.image-meals
  position relative
  background-color lightgray
  width 100%
  height 0
  overflow hidden
  padding-bottom 56.25%
  img
    position absolute
    width 100%
    height 100%
    top 0
    right 0
    bottom 0
    left 0
    object-fit cover
  .placeholder
    position absolute
    width 50%
    height auto
    top 0
    right 0
    bottom 0
    left 0
    margin auto
    img
      object-fit unset
.carousel-cell
  width 100%
  text-align center
</style>
